module.exports = __webpack_public_path__ + "static/media/tradeServUnif.d332a952.webp";